import { render, staticRenderFns } from "./PaymentStatusFpx.vue?vue&type=template&id=32cd10a3"
import script from "./PaymentStatusFpx.vue?vue&type=script&lang=js"
export * from "./PaymentStatusFpx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports